/* eslint-disable */
import api from "@/api";
import router from "@/router";
import {defineStore} from "pinia/dist/pinia";
import packageJson from "../../package.json";
import {useUserStore} from "@/stores/user";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useApi} from "@/services/useApi.js";
import {client} from '@/stores/client.js'

export const usePaymentMethodsStore = defineStore('paymentMethods', {
  state: () => ({
    paymentMethods: [],
  }),
  getters: {
    getPaymentMethods(state) {
      return state.paymentMethods;
    },
  },
  actions: {
    async action_getPaymentMethods() {
      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 10079,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential
        },
        "client": client
      };
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('getPaymentMethods', data)
          if (data.response === 100) {
            this.paymentMethods = data.account.billings
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          }
        })

    },
    async action_getPaymentMethods2(payload = null) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 10079,
        ...(payload?.id && {
          profile: {
            id: payload.id
          }
        })
      };
      return await useApi(
        request,
        (response) => {
          const data = response.data?.account.billings

          return {
            result: true,
            'data': data
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async addPaymentMethod(payload) {
      const userStore = useUserStore()
      //console.log(payload.type)
      const request = {
        "request": 1009,
        "subRequest": 10080,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential,
          "billing": {
            "type": payload.type,
            "name": payload.name,
          }
        },
        "client": client
      };
      if (payload.type === "Crypto") {
        request.account.billing.crypto = {
          "network": payload.network,
          "address": payload.address
        };
      } else if (payload.type === "Rial") {
        request.account.billing.rial = {
          "iban": payload.iban,
          "cardNumber": payload.cardNumber
        };
      }
      //console.log(request)
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('addPaymentMethod', data)
          if (data.response === 100) {
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          } else {
            // commit('setErrorMessage', data.message)
            return false
          }
        })

    },
    async action_addPaymentMethod2(payload = null) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 10080,
        ...(payload?.profile?.id && {
          profile: {
            id: payload.profile.id,
          },
        }),
        account: {
          ...getAuthenticatedRequest().account,
          billing: {
            type: payload.type,
            name: payload.name,
            ...(payload.type === 'Crypto'
              ? {
                crypto: {
                  network: payload.crypto.network,
                  address: payload.crypto.address,
                },
              }
              : {
                rial: {
                  iban: payload.rial.iban,
                  cardNumber: payload.rial.cardNumber,
                },
              }),
          },
        },
      }

      return await useApi(
        request,
        (response) => {
          console.log(response)
          const data = response.data
          return {
            result: true,
            'data': data
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async updatePaymentMethod(payload) {
      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 10081,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential,
          "billing": {
            "id": payload.id,
            "type": payload.type,
            "name": payload.name,
          }
        },
        "client": client
      };
      if (payload.type === "Crypto") {
        request.account.billing.crypto = {
          "network": payload.network,
          "address": payload.address
        };
      } else if (payload.type === "Rial") {
        request.account.billing.rial = {
          "iban": payload.iban,
          "cardNumber": payload.cardNumber
        };
      }
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('updatePaymentMethod', data)
          if (data.response === 100) {
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          } else {
            // commit('setErrorMessage', data.message)
            return false
          }
        })

    },
    async action_updatePaymentMethod2(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 10081,
        ...(payload?.profile?.id && {
          profile: {
            id: payload.profile.id,
          },
        }),
        account: {
          ...getAuthenticatedRequest().account,
          billing: {
            id: payload.id,
            type: payload.type,
            name: payload.name,
            ...(payload.type === 'Crypto'
              ? {
                crypto: {
                  network: payload.crypto.network,
                  address: payload.crypto.address,
                },
              }
              : {
                rial: {
                  iban: payload.rial.iban,
                  cardNumber: payload.rial.cardNumber,
                },
              }),
          },
        },
      }

      return await useApi(
        request,
        (response) => {
          return {
            result: true
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async removePaymentMethod(payload) {
      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 10082,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential,
          "billing": {
            "id": payload.id,
          }
        },
        "client": client
      };
      console.log(request)
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          console.log('removePaymentMethod', data)
          if (data.response === 100) {
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          } else {
            userStore.errorMessage = data.message
            return false
          }
        })

    },
    async action_removePaymentMethod2(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 10082,
        ...(payload?.profile?.id && {
          "profile": {
            "id": payload.profile.id,
          },
        }),
        "account": {
          ...getAuthenticatedRequest().account,
          "billing": {
            "id": payload.billing.id,
          },
        },
      };
      return await useApi(
        request,
        (response) => {
          return {
            result: true
          }
        },
        (errorMessage) => {
          console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async withdraw(payload) {
      const userStore = useUserStore()
      const request = {
        "request": 1009,
        "subRequest": 10084,
        "account": {
          "id": userStore.getUserId,
          "credential": userStore.getCredential,
          "billing": {
            "id": payload.billingId,
          },
          "transaction": {
            "amount": payload.amount
          }
        },
        "client": client
      };
      return await api.post('', request)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          } else {
            console.log('response is ' + res.status)
          }
        }).then((data) => {
          //console.log('withdraw', data)
          if (data.response === 100) {
            return true
          } else if (data.response === -100002) {
            userStore.resetUser('your credential is expired');
            router.push({name: 'Login'})
          } else {
            //commit('setErrorMessage', data.message)
            return false
          }
        })
    }
  },
})

